module.exports = __webpack_public_path__ + "img/paysage-drone-lazy.dd909359.jpg";